var map = {
	"./": 90445,
	"./App": 73465,
	"./App.tsx": 73465,
	"./MIGRATION_GUIDE.md": 54211,
	"./Vazir-Medium.ttf": 68975,
	"./api/BaseURL": 15485,
	"./api/BaseURL.ts": 15485,
	"./api/auth/api": 5390,
	"./api/auth/api.ts": 5390,
	"./api/clinet": 15097,
	"./api/clinet.ts": 15097,
	"./api/comments/api": 20944,
	"./api/comments/api.ts": 20944,
	"./api/contact-us/api": 59036,
	"./api/contact-us/api.ts": 59036,
	"./api/galleries-media/api": 49698,
	"./api/galleries-media/api.ts": 49698,
	"./api/galleries/api": 52030,
	"./api/galleries/api.ts": 52030,
	"./api/posts-media/api": 10671,
	"./api/posts-media/api.ts": 10671,
	"./api/posts/api": 20978,
	"./api/posts/api.ts": 20978,
	"./assets.d": 9862,
	"./assets.d.ts": 9862,
	"./assets/bg-contact-us.png": 14744,
	"./assets/contentMedia/gallery/1.jpeg": 1876,
	"./assets/contentMedia/gallery/10.jpeg": 12183,
	"./assets/contentMedia/gallery/11.jpeg": 82848,
	"./assets/contentMedia/gallery/12.jpeg": 58931,
	"./assets/contentMedia/gallery/13.jpeg": 12715,
	"./assets/contentMedia/gallery/14.jpeg": 47497,
	"./assets/contentMedia/gallery/15.jpeg": 14852,
	"./assets/contentMedia/gallery/16.jpeg": 42718,
	"./assets/contentMedia/gallery/2.jpeg": 11571,
	"./assets/contentMedia/gallery/3.jpeg": 38054,
	"./assets/contentMedia/gallery/4.jpeg": 27492,
	"./assets/contentMedia/gallery/5.jpeg": 69188,
	"./assets/contentMedia/gallery/6.jpeg": 70585,
	"./assets/contentMedia/gallery/7.jpeg": 64245,
	"./assets/contentMedia/gallery/8.jpeg": 47023,
	"./assets/contentMedia/gallery/9.jpeg": 99116,
	"./assets/contentMedia/posts/1.webp": 79913,
	"./assets/contentMedia/posts/2.webp": 14893,
	"./assets/contentMedia/posts/3.webp": 72790,
	"./assets/contentMedia/posts/4.jpg": 35720,
	"./assets/contentMedia/posts/5.webp": 34273,
	"./assets/contentMedia/posts/6.webp": 36192,
	"./assets/contentMedia/posts/7.webp": 86438,
	"./assets/contentMedia/posts/8.jpg": 11185,
	"./assets/contentMedia/posts/9.webp": 14944,
	"./assets/expertise-bg.webp": 18272,
	"./assets/services/occupational-therapy.png": 56278,
	"./assets/services/physiotherapy.png": 11606,
	"./assets/services/psychological-counseling.png": 70315,
	"./assets/services/services-img.png": 97892,
	"./assets/services/speech-therapy.png": 15556,
	"./assets/stats/aaa.png": 90501,
	"./assets/stats/doctor-patient.png": 13265,
	"./assets/stats/examination.png": 13189,
	"./assets/stats/health-report.png": 92477,
	"./assets/stats/stats.png": 19197,
	"./constants/global": 24259,
	"./constants/global.ts": 24259,
	"./css/admin/Loading.css": 9426,
	"./css/admin/_variablesAdmin.scss": 24978,
	"./css/admin/addPatient.css": 56836,
	"./css/admin/addPatient.css.map": 50006,
	"./css/admin/addPatient.scss": 1995,
	"./css/admin/adminPanel.css": 73998,
	"./css/admin/adminPanel.css.map": 44801,
	"./css/admin/adminPanel.scss": 59752,
	"./css/admin/createContent.css": 75097,
	"./css/admin/createContent.css.map": 47539,
	"./css/admin/createContent.scss": 70503,
	"./css/admin/header.css": 85188,
	"./css/admin/header.css.map": 24354,
	"./css/admin/header.scss": 62159,
	"./css/admin/main.css": 82978,
	"./css/admin/main.css.map": 72429,
	"./css/admin/patientsList.css": 61397,
	"./css/admin/patientsList.css.map": 16487,
	"./css/admin/patientsList.scss": 44863,
	"./css/admin/sidebar.css": 29136,
	"./css/admin/sidebar.css.map": 47986,
	"./css/admin/sidebar.scss": 74711,
	"./css/pages/PreviousComments.css": 39008,
	"./css/pages/PreviousComments.css.map": 39216,
	"./css/pages/PreviousComments.scss": 80036,
	"./css/pages/SmallContentDisplay.css": 30104,
	"./css/pages/SmallContentDisplay.css.map": 93575,
	"./css/pages/comment.css": 9209,
	"./css/pages/comment.css.map": 99537,
	"./css/pages/comment.scss": 1252,
	"./css/pages/contactUs.css": 87774,
	"./css/pages/contactUs.css.map": 53305,
	"./css/pages/contactUs.scss": 57656,
	"./css/pages/contentShow.css": 8203,
	"./css/pages/contentShow.css.map": 79484,
	"./css/pages/contentShow.scss": 18721,
	"./css/pages/errorFallback.css": 48548,
	"./css/pages/errorFallback.css.map": 63019,
	"./css/pages/errorFallback.scss": 86000,
	"./css/pages/expertise.css": 22391,
	"./css/pages/expertise.css.map": 58101,
	"./css/pages/expertise.scss": 21569,
	"./css/pages/footer.css": 91017,
	"./css/pages/footer.css.map": 86011,
	"./css/pages/footer.scss": 8259,
	"./css/pages/gallerySection.css": 71889,
	"./css/pages/gallerySection.css.map": 71226,
	"./css/pages/gallerySection.scss": 22514,
	"./css/pages/headerMain.css": 56183,
	"./css/pages/headerMain.css.map": 82956,
	"./css/pages/headerMain.scss": 50652,
	"./css/pages/hero.css": 48071,
	"./css/pages/hero.css.map": 86400,
	"./css/pages/hero.scss": 17133,
	"./css/pages/login.css": 21110,
	"./css/pages/login.css.map": 59101,
	"./css/pages/login.scss": 7352,
	"./css/pages/mainPage.css": 98819,
	"./css/pages/mainPage.css.map": 10820,
	"./css/pages/mainPage.scss": 5816,
	"./css/pages/notFound.css": 9905,
	"./css/pages/notFound.css.map": 65325,
	"./css/pages/notFound.scss": 92687,
	"./css/pages/search.css": 24795,
	"./css/pages/search.css.map": 667,
	"./css/pages/search.scss": 5250,
	"./css/pages/services.css": 64941,
	"./css/pages/services.css.map": 99570,
	"./css/pages/services.scss": 66523,
	"./css/pages/sidebar.css": 67896,
	"./css/pages/sidebar.css.map": 46683,
	"./css/pages/sidebar.scss": 32826,
	"./css/pages/siderbar.css": 19034,
	"./css/pages/siderbar.css.map": 61750,
	"./css/pages/singleContentShow.css": 12029,
	"./css/pages/singleContentShow.css.map": 2684,
	"./css/pages/singleContentShow.scss": 75367,
	"./css/pages/slider.css": 2124,
	"./css/pages/slider.css.map": 4454,
	"./css/pages/slider.scss": 18958,
	"./css/pages/smallContentDisplay.scss": 77495,
	"./css/pages/stats.css": 40688,
	"./css/pages/stats.css.map": 72963,
	"./css/pages/stats.scss": 14170,
	"./example/ContentShowReactQuery": 95088,
	"./example/ContentShowReactQuery.tsx": 95088,
	"./helpers/ErrorBoundary": 83130,
	"./helpers/ErrorBoundary.tsx": 83130,
	"./helpers/ErrorFallback": 29976,
	"./helpers/ErrorFallback.tsx": 29976,
	"./index": 90445,
	"./index.css": 51174,
	"./index.tsx": 90445,
	"./pages/ContactUs": 49563,
	"./pages/ContactUs.tsx": 49563,
	"./pages/Expertise": 35402,
	"./pages/Expertise.tsx": 35402,
	"./pages/Login": 7107,
	"./pages/Login.tsx": 7107,
	"./pages/MainPage": 71277,
	"./pages/MainPage.tsx": 71277,
	"./pages/NotFound": 64949,
	"./pages/NotFound.tsx": 64949,
	"./pages/SingleContentShow": 38262,
	"./pages/SingleContentShow.tsx": 38262,
	"./pages/admin/AddPatient": 13914,
	"./pages/admin/AddPatient.tsx": 13914,
	"./pages/admin/AdminPanel": 55539,
	"./pages/admin/AdminPanel.tsx": 55539,
	"./pages/admin/CreateGallery": 8725,
	"./pages/admin/CreateGallery.tsx": 8725,
	"./pages/admin/CreatePost": 56458,
	"./pages/admin/CreatePost.tsx": 56458,
	"./pages/admin/DeletePatient": 62250,
	"./pages/admin/DeletePatient.tsx": 62250,
	"./pages/admin/EditPatient": 24788,
	"./pages/admin/EditPatient.tsx": 24788,
	"./pages/admin/PatientsList": 68654,
	"./pages/admin/PatientsList.tsx": 68654,
	"./pages/admin/components/Header": 27124,
	"./pages/admin/components/Header.tsx": 27124,
	"./pages/admin/components/Loading": 70907,
	"./pages/admin/components/Loading.tsx": 70907,
	"./pages/admin/components/Modal": 93507,
	"./pages/admin/components/Modal.tsx": 93507,
	"./pages/admin/components/Sidebar": 63735,
	"./pages/admin/components/Sidebar.tsx": 63735,
	"./pages/components/Comment": 97026,
	"./pages/components/Comment.tsx": 97026,
	"./pages/components/ContentShow": 11014,
	"./pages/components/ContentShow.tsx": 11014,
	"./pages/components/Footer": 49510,
	"./pages/components/Footer.tsx": 49510,
	"./pages/components/Gallery": 20430,
	"./pages/components/Gallery.tsx": 20430,
	"./pages/components/HeaderMain": 68112,
	"./pages/components/HeaderMain.tsx": 68112,
	"./pages/components/Hero": 16200,
	"./pages/components/Hero.tsx": 16200,
	"./pages/components/PreviousComments": 33283,
	"./pages/components/PreviousComments.tsx": 33283,
	"./pages/components/ScrollToTop": 65498,
	"./pages/components/ScrollToTop.tsx": 65498,
	"./pages/components/Services": 51069,
	"./pages/components/Services.tsx": 51069,
	"./pages/components/Sidebar": 18931,
	"./pages/components/Sidebar.tsx": 18931,
	"./pages/components/Slider": 16464,
	"./pages/components/Slider.tsx": 16464,
	"./pages/components/SmallContentDisplay": 30666,
	"./pages/components/SmallContentDisplay.tsx": 30666,
	"./pages/components/Stats": 3108,
	"./pages/components/Stats.tsx": 3108,
	"./pages/components/drawer": 58626,
	"./pages/components/drawer/": 58626,
	"./pages/components/drawer/index": 58626,
	"./pages/components/drawer/index.tsx": 58626,
	"./pages/components/loadingIndicator": 70705,
	"./pages/components/loadingIndicator/": 70705,
	"./pages/components/loadingIndicator/BaseSkeleton": 61926,
	"./pages/components/loadingIndicator/BaseSkeleton.tsx": 61926,
	"./pages/components/loadingIndicator/index": 70705,
	"./pages/components/loadingIndicator/index.tsx": 70705,
	"./pages/components/loadingIndicator/style": 97690,
	"./pages/components/loadingIndicator/style.ts": 97690,
	"./pages/components/singleContentSlider": 24981,
	"./pages/components/singleContentSlider.tsx": 24981,
	"./pages/layout": 30319,
	"./pages/layout.tsx": 30319,
	"./pages/layout/PublicLayout": 73430,
	"./pages/layout/PublicLayout.tsx": 73430,
	"./persistor": 61059,
	"./persistor.ts": 61059,
	"./queries": 19574,
	"./queries/": 19574,
	"./queries/auth": 3310,
	"./queries/auth/": 3310,
	"./queries/auth/index": 3310,
	"./queries/auth/index.ts": 3310,
	"./queries/auth/use-get-current-user": 44771,
	"./queries/auth/use-get-current-user.ts": 44771,
	"./queries/auth/use-login": 3271,
	"./queries/auth/use-login.ts": 3271,
	"./queries/auth/use-logout": 5859,
	"./queries/auth/use-logout.ts": 5859,
	"./queries/comments": 83583,
	"./queries/comments/": 83583,
	"./queries/comments/index": 83583,
	"./queries/comments/index.ts": 83583,
	"./queries/comments/use-create-comment": 65054,
	"./queries/comments/use-create-comment.ts": 65054,
	"./queries/comments/use-get-comments-by-content-id": 76606,
	"./queries/comments/use-get-comments-by-content-id.ts": 76606,
	"./queries/contact-use": 5331,
	"./queries/contact-use/": 5331,
	"./queries/contact-use/index": 5331,
	"./queries/contact-use/index.ts": 5331,
	"./queries/contact-use/use-create-contact-us": 18994,
	"./queries/contact-use/use-create-contact-us.ts": 18994,
	"./queries/galleries": 29580,
	"./queries/galleries-media": 66411,
	"./queries/galleries-media/": 66411,
	"./queries/galleries-media/index": 66411,
	"./queries/galleries-media/index.ts": 66411,
	"./queries/galleries-media/use-create-gallery-media": 54471,
	"./queries/galleries-media/use-create-gallery-media.ts": 54471,
	"./queries/galleries-media/use-delete-gallery-media": 41051,
	"./queries/galleries-media/use-delete-gallery-media.ts": 41051,
	"./queries/galleries-media/use-get-galleries-media": 37876,
	"./queries/galleries-media/use-get-galleries-media-by-gallery-id": 62293,
	"./queries/galleries-media/use-get-galleries-media-by-gallery-id.ts": 62293,
	"./queries/galleries-media/use-get-galleries-media.ts": 37876,
	"./queries/galleries-media/use-update-gallery-media": 80616,
	"./queries/galleries-media/use-update-gallery-media.ts": 80616,
	"./queries/galleries/": 29580,
	"./queries/galleries/index": 29580,
	"./queries/galleries/index.ts": 29580,
	"./queries/galleries/use-create-gallery": 51897,
	"./queries/galleries/use-create-gallery.ts": 51897,
	"./queries/galleries/use-delete-gallery": 82880,
	"./queries/galleries/use-delete-gallery.ts": 82880,
	"./queries/galleries/use-get-galleries": 1152,
	"./queries/galleries/use-get-galleries.ts": 1152,
	"./queries/galleries/use-get-gallery-by-id": 47178,
	"./queries/galleries/use-get-gallery-by-id.ts": 47178,
	"./queries/galleries/use-update-gallery": 25537,
	"./queries/galleries/use-update-gallery.ts": 25537,
	"./queries/index": 19574,
	"./queries/index.ts": 19574,
	"./queries/posts": 24338,
	"./queries/posts-media": 58612,
	"./queries/posts-media/": 58612,
	"./queries/posts-media/index": 58612,
	"./queries/posts-media/index.ts": 58612,
	"./queries/posts-media/use-create-post-media": 76005,
	"./queries/posts-media/use-create-post-media.ts": 76005,
	"./queries/posts-media/use-delete-post-media": 12347,
	"./queries/posts-media/use-delete-post-media.ts": 12347,
	"./queries/posts-media/use-get-posts-media": 48209,
	"./queries/posts-media/use-get-posts-media-by-post-id": 32970,
	"./queries/posts-media/use-get-posts-media-by-post-id.ts": 32970,
	"./queries/posts-media/use-get-posts-media.ts": 48209,
	"./queries/posts-media/use-update-post-media": 32951,
	"./queries/posts-media/use-update-post-media.ts": 32951,
	"./queries/posts/": 24338,
	"./queries/posts/index": 24338,
	"./queries/posts/index.ts": 24338,
	"./queries/posts/use-create-post": 59783,
	"./queries/posts/use-create-post.ts": 59783,
	"./queries/posts/use-delete-post": 41460,
	"./queries/posts/use-delete-post.ts": 41460,
	"./queries/posts/use-get-post-by-id": 21128,
	"./queries/posts/use-get-post-by-id.ts": 21128,
	"./queries/posts/use-get-posts": 13061,
	"./queries/posts/use-get-posts.ts": 13061,
	"./queries/posts/use-update-post": 39369,
	"./queries/posts/use-update-post.ts": 39369,
	"./queries/query-client": 25991,
	"./queries/query-client.ts": 25991,
	"./queries/use-get-content-by-id": 46323,
	"./queries/use-get-content-by-id.ts": 46323,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;